import React, { Component } from 'react';
import SumaContexto from '../../contexto/SumaContexto';
import { withRouter } from "react-router-dom";
import { SearchOutlined } from '@ant-design/icons';
import { Spin, Table, Modal, Progress } from 'antd';
import ServicioUsuarios from '../../servicios/usuarios/ServicioUsuarios'
import ServicioAdministracion from '../../servicios/ServicioAdministracion'
import { withCookies } from 'react-cookie';
import Constantes from '../../utilidades/Constantes'
import FiltroColumna from '../../general/tabla/FiltroColumna'
import FiltroEtiqueta from '../../general/tabla/FiltroEtiqueta'
//import moment from 'moment';
import _ from 'lodash';




class ReportePersonasJuridicas extends Component {

    static contextType = SumaContexto;

    ENUM_COMPONENTE = {
        CARGANDO: 1,
        VER: 2,
        NO_DISPONIBLE: 3,
    }

    state = {
        componente: this.ENUM_COMPONENTE.CARGANDO,
        descargando: false,

        filtro: {},
        filtroEtiquetas: [],
        filtroApi : {},
        paginacion: {
            current: 1,
            pageSize: 10,
        },
        cargandoTabla: true
    };

    constructor(props) {
        super(props);
        this.servicioUsuarios = new ServicioUsuarios(props);
        this.servicioAdministracion = new ServicioAdministracion(props);

        let contexto = this;
        this.filtroColumna = new FiltroColumna(props, (valores) => { contexto.setSumaState(valores, contexto) });
    }

    componentDidMount() {
        this._isMounted = true;
        this.props.onRef(this)
        this.cargarDatosIniciales();
    }

    componentWillUnmount() {
        this._isMounted = false;
        this.props.onRef(undefined)
    }

    setSumaState(valores) {
        if (this._isMounted) {
            this.setState(valores);
        }
    }

    // -----------------------------------------------------------------------
    // --- CARGA DATOS INICIALES ---------------------------------------------
    // -----------------------------------------------------------------------
    async cargarDatosIniciales() {
        // Validando que el usuario esté en sesion
        let usr = await this.servicioUsuarios.usuarioEnSesion();
        if (usr != null) {
            await this.cargarDatosTabla(this);
            this.setSumaState({componente: this.ENUM_COMPONENTE.VER, cargando: false,usuario: usr});

        } else {
            this.setSumaState({ componente: this.ENUM_COMPONENTE.NO_DISPONIBLE });
        }
        // Esto le avisa al contenedor padre (ReportesUsuarios.js) que ya cargó lo datos
        this.props.onCargado(true);
    }

    // 'limpiarFiltro': Método (clearFilters) que es propio de la tabla antDesign para limpiar los filtros
    // 'confirmarFiltro': Método (confirm) que es própio de la tabla antDesign para aplicar el filtro
    // 'dataIndex': Retorna el campo que se está filtrando
    // 'selectedKeys': Retorna el valor a filtrar;
    async cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) {
        let filtro = contexto.state.filtro;
        if (dataIndex !== undefined) { // Si el filtro es aplicado, se agrega la columna filtrada
            filtro[dataIndex] = selectedKeys;
        }
        contexto.setSumaState({ filtro: filtro });

        // Se construye el filtroApi a partir de lo que fue filtrado en la tabla
        let filtroApi = {
            ...(filtro.id && filtro.id.length > 0 && { id: filtro.id[0] }),
            ...(filtro.razonSocial && filtro.razonSocial.length > 0 && { razonSocial: filtro.razonSocial[0] }),
            ...(filtro.nit && filtro.nit.length > 0 && { nit: filtro.nit[0] }),
            ...(filtro.camaraComercio && filtro.camaraComercio.length > 0 && { camaraComercio: filtro.camaraComercio[0] }),
            ...(filtro.sector && filtro.sector.length > 0 && { sector: filtro.sector[0] }),
            ...(filtro.ciudad && filtro.ciudad.length > 0 && { ciudad: filtro.ciudad[0] }),
            ...(filtro.fechaCreacionFormato && filtro.fechaCreacionFormato.length > 0 && { fechasCreacion: filtro.fechaCreacionFormato[0] + '-' + filtro.fechaCreacionFormato[1] }),
            detallado:this.props.detallado
        };

        const paginacion = this.state.paginacion;
        let paginacionApi = {
            paginaActual:this.state.paginacion.current,
            paginaTamano:this.state.paginacion.pageSize,
            ordenarColumna:this.state.paginacion.ordenarColumna,
            orden: this.state.paginacion.orden
        }

        let cambio = false;
        // Primero valida si hubo cambio a nivel de filtro
        if( !_.isEqual(this.state.filtroApi, filtroApi) ){
            paginacion.current = 1;
            paginacionApi.paginaActual = 1;
            cambio = true;
        }

        // Segundo valida si hubo cambio a nivel de paginación
        if( !cambio && !_.isEqual(this.state.paginacionApi, paginacionApi) ){
            cambio = true;
        }
        
        if( !cambio ){
            // Si no hubo cambio no se hace nada
            return;
        }

        contexto.setSumaState({  
            cargandoTabla: true, 
            filtro, 
            filtroApi, 
            paginacionApi, 
            paginacion
        });

        await this.servicioAdministracion.obtenerPersonasJuridicas(
                {
                    ...filtroApi,
                    ...paginacionApi
                }
            )
            .then((respuestaApi) => {
                if (respuestaApi) {
                    
                    switch (respuestaApi.codigo) {
                        case Constantes.ENUMS_API.ADMINISTRACION.DATOS_RETORNADOS.id:
                            let tablaPaginada = respuestaApi.resultado;
                            const paginacion = this.state.paginacion;
                            paginacion.total = tablaPaginada.total;

                            contexto.setSumaState({
                                personasJuridicas: tablaPaginada.registros,
                                cargandoTabla: false,
                                paginacion
                            });
                            
                            break;
                        default: break;
                    }
                    
                }
            }).then(() => {
                if (limpiarFiltro !== undefined) { limpiarFiltro(); }
                if (confirmarFiltro !== undefined) { confirmarFiltro(); }
            });
    }

    async descargarReporte() {
        let contexto = this;
        contexto.setSumaState({descargando:true,porcentaje:0});
        await this.servicioAdministracion.descargarReportePersonasJuridicas(
            {
                ...this.state.filtroApi,
                ...this.state.paginacionApi,
                paginaActual : 1,
                paginaTamano : -1
            },
            ( percentCompleted ) => { 
                contexto.setSumaState({porcentaje:percentCompleted});
            }
            )
            .then((respuesta) => {
                if (respuesta) {
                    switch (respuesta.status) {
                        case 200:
                            const type = respuesta.headers['content-type'];
                            const nombre = respuesta.headers['filename'];
                            const blob = new Blob([respuesta.data], { type: type });
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.download = nombre;
                            link.click();
                            link.remove();
                            this.setSumaState({descargando:false});
                            break;
                        default:
                            this.setSumaState({descargando:false});
                            Modal.error({ content: "No fue posible generar el reporte de las personas jurídicas. [Cod:RPJ01]" });
                            break;
                    }
                }
            });
    }

    handleTableChange = async (pagination, filters, sorter) => {
        const paginacion = this.state.paginacion;
        paginacion.current = pagination.current;
        paginacion.pageSize = pagination.pageSize;
        paginacion.ordenarColumna = sorter.field;
        paginacion.orden = sorter.order;
        this.setSumaState({  paginacion });
        await this.cargarDatosTabla(this);
    };

    render() {

        const { personasJuridicas, componente, descargando,porcentaje } = this.state;
        const { detallado } = this.props;

        let { filtro } = this.state;
        filtro = filtro || {};
        let contexto = this;

        const columns = [
            ...(detallado ? 
            [{
                title: 'Id',
                dataIndex: 'id',
                key: 'id',
                with: 100,
                sorter: (a, b) => 0, //a.id - b.id,
                filteredValue: filtro.id || null,
                ...this.filtroColumna.busquedaTexto(
                    'Identificador',
                    'id',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            }]:[]),
            {
                title: 'Razón social',
                dataIndex: 'razonSocial',
                key: 'razonSocial',
                sorter: (a, b) => 0, //a.razonSocial ? a.razonSocial.localeCompare(b.razonSocial) : 1,
                filteredValue: filtro.razonSocial || null,
                ...this.filtroColumna.busquedaTexto(
                    'Razón social',
                    'razonSocial',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            },
            {
                title: 'Nit',
                dataIndex: 'nit',
                key: 'nit',
                sorter: (a, b) => 0, //a.nit ? a.nit.localeCompare(b.nit) : 1,
                filteredValue: filtro.nit || null,
                ...this.filtroColumna.busquedaTexto(
                    'Nit',
                    'nit',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            },
            {
                title: 'Cámara comercio',
                dataIndex: 'camaraComercio',
                key: 'camaraComercio',
                sorter: (a, b) => 0, //a.camaraComercio ? a.camaraComercio.localeCompare(b.camaraComercio) : 1,
                filteredValue: filtro.camaraComercio || null,
                ...this.filtroColumna.busquedaTexto(
                    'Cámara comercio',
                    'camaraComercio',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            },
            {
                title: 'Sector',
                dataIndex: 'sector',
                key: 'sector',
                sorter: (a, b) => 0, //a.sector ? a.sector.localeCompare(b.sector) : 1,
                filteredValue: filtro.sector || null,
                ...this.filtroColumna.busquedaTexto(
                    'Sector',
                    'sector',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            },
            {
                title: 'Ciudad',
                dataIndex: 'ciudad',
                key: 'ciudad',
                sorter: (a, b) => 0, //a.ciudad ? a.ciudad.localeCompare(b.ciudad) : 1,
                filteredValue: filtro.ciudad || null,
                ...this.filtroColumna.busquedaTexto(
                    'Ciudad',
                    'ciudad',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            },
            {
                title: 'Fecha Creación',
                align: 'center',
                dataIndex: 'fechaCreacionFormato',
                key: 'fechaCreacionFormato',
                width: 100,
                sorter: (a, b) => 0, //moment(a.fechaCreacionEstandar, Constantes.FORMATO_FECHA_TIEMPO_ESTANDAR) - moment(b.fechaCreacionEstandar, Constantes.FORMATO_FECHA_TIEMPO_ESTANDAR),
                filteredValue: filtro.fechaCreacionFormato || null,
                ...this.filtroColumna.busquedaFecha(
                    'Fecha Creación',
                    'fechaCreacionFormato',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                )
            },
            
        ];

        return (
            <div>
                {(componente === this.ENUM_COMPONENTE.VER) ?
                    (
                        <Spin tip="Por favor espera..." size="large" spinning={this.state.cargando}>

                            <Modal
                                visible={descargando}
                                closable={false}
                                footer={null}
                                width={320}
                                style={{textAlign:'center'}}
                            >
                                <label style={{marginBottom:13,display:'block'}}>
                                    Generando reporte...
                                </label>
                                <Progress type="circle" percent={porcentaje} width={80} />
                            </Modal>

                            {
                                this.state.filtroEtiquetas.length > 0 ?
                                    (<div className="seccion-filtros-etiquetas">
                                        <div className="titulo-filtro-etiquetas">
                                            <label>Filtros <SearchOutlined /> :</label>
                                        </div>

                                        {
                                            this.state.filtroEtiquetas.map((filtroEtiqueta, i) => {
                                                return (
                                                    <FiltroEtiqueta key={i}
                                                        dataIndex={filtroEtiqueta.dataIndex}
                                                        texto={filtroEtiqueta.texto}
                                                        onClose={filtroEtiqueta.borrarFiltro} />
                                                )
                                            })
                                        }
                                    </div>)
                                    :
                                    (<></>)
                            }

                            <Table columns={columns}
                                dataSource={personasJuridicas}
                                rowKey={"id"}
                                onChange={this.handleTableChange}
                                pagination={this.state.paginacion}
                                loading={this.state.cargandoTabla} />
                        </Spin>
                    )
                    :
                    (componente === this.ENUM_COMPONENTE.CARGANDO) ?
                        (<Spin tip="Por favor espera..." className="solo-spin-cargando" size="large" />)
                        : ((componente === this.ENUM_COMPONENTE.NO_DISPONIBLE) ? (<label>Contenido no disponible. [Cod:REPPERJUR]</label>) : (<></>))
                }
            </div>

        );

    }

}

export default withRouter(withCookies(ReportePersonasJuridicas));